class CartUpsell extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-upsell-variants]')
    this.submitButton = this.querySelector('[data-upsell-submit]')
    this.priceElement = this.querySelector('[data-upsell-price]')
    this.compareElement = this.querySelector('[data-upsell-compare]')
    this.sizeElements = this.querySelectorAll('[data-upsell-size]')

    this.select.addEventListener('change', this.onVariantChange)
    this.submitButton.addEventListener('click', this.addToCart)
  }

  get selectedOption() {
    return this.select.options[this.select.selectedIndex]
  }

  onVariantChange = () => {
    const option = this.selectedOption
    if (!option) return

    this.priceElement.textContent = option.dataset.price
    this.compareElement.textContent = option.dataset.compare
    this.compareElement.hidden = !option.dataset.compare

    this.sizeElements.forEach((element) => {
      element.textContent = option.dataset.size
    })
  }

  addToCart = () => {
    const option = this.selectedOption
    if (!option) return

    document.body.classList.add('cart-updating')

    const item = {
      id: Number(option.value),
      quantity: 1,
      properties: {
        _add_source: 'cart-upsell'
      }
    }

    if (option.dataset.sellingPlan) {
      item.selling_plan = Number(option.dataset.sellingPlan)
    }

    const data = {
      items: [item],
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then((response) => response.json())
      .then((responseJSON) => {
        if (responseJSON.status) {
          throw new Error(responseJSON.description || responseJSON.message || 'Add to cart failed')
        }

        const upsellRoot = document.getElementById('cart-upsell')
        const discountCode = upsellRoot?.dataset.discountCode
        const fromLanding = upsellRoot?.dataset.fromLanding === 'true'
        if (discountCode && item.selling_plan && !fromLanding) {
          const root = window.Shopify.routes.root || '/'
          window.location.href = `${root}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(`${root}cart`)}`
          return
        }

        this.updateSections(responseJSON.sections)
        document.body.classList.remove('cart-updating')
      })
      .catch((error) => {
        console.error('Error:', error)
        document.body.classList.remove('cart-updating')
      })
  }

  updateSections = (sections) => {
    if (!sections) return

    this.getSectionsToRender().forEach((section) => {
      const container = document.getElementById(section.id)
      if (!container) return

      const elementToReplace = container.querySelector(section.selector) || container
      elementToReplace.innerHTML = this.getSectionInnerHTML(sections[section.section], section.selector)
    })
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '#main-cart-footer'
      },
      {
        id: 'cart-upsell',
        section: document.getElementById('cart-upsell').dataset.id,
        selector: '#cart-upsell'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ]
  }
}

customElements.define('cart-upsell', CartUpsell)
